import { ifElseTransformCreator, IfElseType } from './calculations/IfElseCalculation';
import { simplePredicateTransformCreator, SimplePredicateType } from './calculations/SimplePredicateCalculation';
import { rowShiftTransformCreator, RowShiftType } from './calculations/RowShiftCalculation';
import { timeShiftTransformCreator, TimeShiftType } from './calculations/TimeShiftCalculation';
import { constantColumnTransformCreator, ConstantType } from './calculations/ConstantCalculation';
import { TransformRegistry } from './transform';

/**
 * The Default registry of named TransformCreator functions.
 *
 * New calculation types must be added here to be made available to `materializeTable`.
 */
export const DefaultTransformRegistry: TransformRegistry = {
  [TimeShiftType]: timeShiftTransformCreator,
  [RowShiftType]: rowShiftTransformCreator,
  [IfElseType]: ifElseTransformCreator,
  [SimplePredicateType]: simplePredicateTransformCreator,
  [ConstantType]: constantColumnTransformCreator,
};
